import axios from 'axios'
import ApiEpcReview from "./ApiEpcReview"
import Button from 'react-bootstrap/Button'
import AddressPicker from "./AddressPicker"
import { useDropzone } from 'react-dropzone'
import { useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import CompletedUpload from './CompletedUpload'
import ComparisonTable from "./ComparisonTable"
import ProgressMeterBlob from "./ProgressMeterBlob"
import MobileOnlyWarning from "./MobileOnlyWarning"
import ProcessReportPage from "../ProcessReportPage"
import { useEffect, useState, useCallback } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { MainPageTitle, PageExplainer, CTaxPropertySelect, ImageOptionTile, GenerateReportProgressMeter, CTaxBandSelect, GenerateReportProgressMeterWrapper } from "./EpimsStyledComponents"


function UploadXmlForm({generatePreliminaryReport, userRole, generatePremiumReport, generateUnprocessedPremiumReport, generateUnprocessedPremiumPostcodeReport, userAccreditationScheme, premiumCreditsRemaining})
{
    const routeParams = useParams()

    const navigate = useNavigate()
    
    const [currentStep, setCurrentStep] = useState('selectType')
    const [maxCompletedStep, setMaxCompletedStep] = useState(0)
    const [certificateNumber, setCertificateNumber] = useState()

    const advanceStep = (step) => {
        // never happens
        // if (step === 'selectType') {
        //     setMaxCompletedStep(1)
        //     resetUploadLig()
        //     resetUploadRdSAP()
        //     resetCTax()
        // }
        if (step === 'uploadLig') {
            // if (maxCompletedStep !== 1) {
            setMaxCompletedStep(1)
            resetUploadLig()
            resetUploadRdSAP()
            resetCTax()
            resetBranding()
            resetCustomisation(false)
            // }
        }
        if (step === 'uploadRdSAP') {
            setMaxCompletedStep(2)
            resetUploadRdSAP()
            resetCTax()
            resetBranding()
            resetCustomisation(false)
        }
        if (step === 'cTax') {
            setMaxCompletedStep(3)
            resetCTax()
            resetBranding()
            resetCustomisation(false)
        }
        if (step === 'manualCTax') {
            setMaxCompletedStep(3)
            resetCTax()
            resetBranding()
            resetCustomisation(false)
        }
        if (step === 'branding') {
            setMaxCompletedStep(4)
            resetBranding()
            resetCustomisation(false)
        }
        if (step === 'customise') {
            setMaxCompletedStep(5)
            resetCustomisation(true)
        }

        setCurrentStep(step)
    }

    const resetUploadLig = () => {
        removeXmlAFiles();
        setXmlADisabled(false);    
        setXmlADetail(xmlAInitialMessage);
        setXmlAFilename(null);
        setOriginalAFilename(null);
    }

    const resetUploadRdSAP = () => {
        removeXmlBFiles();
        setXmlBDisabled(false);    
        setXmlBDetail(xmlBInitialMessage);
        setXmlBFilename(null);
        setOriginalBFilename(null);
    }

    const resetCTax = () => {
        setCTaxPropertyAddress("");
        // setPostcodePropertyDetails([]);
        setManualCouncilTaxBandActive(false)
        setManualCTaxBand(null)
    }

    const resetBranding = () => {
        setSelectedBranding('')
    }

    const resetCustomisation = () => {

    }
    
    const [selectedReportType, setSelectedReportType] = useState('')
    const presetReportType = routeParams.presetReportType ?? null

    useEffect(() => {
        // this will also get called when the page loads via 'create report' and have a presetReportType === null,
        // so need to only 'advanceStep' if it was actually intended to skip the report type selection step
        // using the advanceStep funciton will make sure all data is wiped
        if (presetReportType === 'premium') {
            selectPremiumReport()
        } else if (presetReportType === 'preliminary') {
            setSelectedReportType('preliminary')
            advanceStep('uploadLig')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [presetReportType])

    const [manualCouncilTaxBandActive, setManualCouncilTaxBandActive] = useState(false);
    const [manualCTaxBand, setManualCTaxBand] = useState(null);

    // if the dropzone is disabled (becomes disabled once upload autostarts and stays that way)
    const [xmlADisabled, setXmlADisabled] = useState(false);
    const [xmlBDisabled, setXmlBDisabled] = useState(false);

    // initial file upload states...
    const [xmlAFiles, setXMLAFiles] = useState([]);
    const [xmlBFiles, setXMLBFiles] = useState([]);

    // initial file upload messages...
    const xmlAInitialMessage = <div><p className="initialMessage">Drag and drop the LIG XML file in this box</p><p className="initialMessageSub">Or click anywhere in this box to open your file browser</p></div>
    const xmlBInitialMessage = <div><p className="initialMessage">Drag and drop the RdSAP XML file in this box</p><p className="initialMessageSub">Or click anywhere in this box to open your file browser</p></div>

    // display content of the drop zone
    const [xmlADetail, setXmlADetail] = useState(xmlAInitialMessage);
    const [xmlBDetail, setXmlBDetail] = useState(xmlBInitialMessage);

    // filenames as they were named on the users machine, may not be needed but there is a chance some ID exists only in the name
    const [originalAFilename, setOriginalAFilename] = useState(null);
    const [originalBFilename, setOriginalBFilename] = useState(null);

    // filenames as they are put to the server
    const [xmlAFilename, setXmlAFilename] = useState(null);
    const [xmlBFilename, setXmlBFilename] = useState(null);

    const [cTaxPropertyAddress, setCTaxPropertyAddress] = useState("");
    const [postcodePropertyDetails, setPostcodePropertyDetails] = useState([]);

    const [brandings, setBrandings] = useState([])
    const [selectedBranding, setSelectedBranding] = useState('')

    const [customiseReady, setCustomiseReady] = useState(false)
    const [unprocessedReportId, setUnprocessedReportId] = useState(null)

    // values used to the postcode / EPC API search
    const [selectedCertificate, setSelectedCertificate] = useState(null)
    
    // setting the step to uploadLig directly will make sure we don't reset any data that has already been set just because the user changed the report type
    const selectPremiumReport = () => {
        if (userRole === 'estate agent') {
            setMaxCompletedStep(1)
            setSelectedReportType('premium-postcode')
            setCurrentStep('selectAddress')
        } else {
            setMaxCompletedStep(1)
            setSelectedReportType('premium')
            setCurrentStep('uploadLig');
        }
    }

    const userClicksAddress = (entry) => {
        setMaxCompletedStep(2)
        setSelectedCertificate(entry.certificate_number)
        setCurrentStep('reviewEPC')
    }

    const acceptEpc = (cTaxData, certificateNumber) => {
        setMaxCompletedStep(3)
        setCurrentStep('cTax')
        setCertificateNumber(certificateNumber)
        setPostcodePropertyDetails(cTaxData['addresses'])
    }

    // Not used but the comparison table still expects it for now
    const selectPreliminaryReport = () => {
        if (maxCompletedStep < 2) setMaxCompletedStep(2)
        setSelectedReportType('preliminary')
        setCurrentStep('uploadLig');
    }

    const ligComplete = () => {
        if (requiresRdSAP()) {
            advanceStep('uploadRdSAP')
        } else {
            advanceStep('cTax')
        }
    }

    const userClicksCTaxAddress = (address) => {
        advanceStep('branding')
        setCTaxPropertyAddress(address)
    }

    const userClicksCTaxOverride = () => {
        advanceStep('manualCTax')
        setManualCouncilTaxBandActive(true)
    }

    const userClicksRejectCTaxOverride = () => {
        advanceStep('cTax')
        setManualCouncilTaxBandActive(false)
    }

    const userClicksManualCTaxBand = (band) => {
        advanceStep('branding')
        setManualCTaxBand(band)
    }

    const userClicksBranding = (brandingId) => {
        if (selectedBranding === brandingId) {
            // user has selected the same thing again, we don't actually need to update anything
            // though we could apply similar logic to the 
            setCurrentStep('customise')
        } else {
            setSelectedBranding(brandingId)
            if (selectedReportType === 'premium-postcode') {
                _generateUnprocessedPremiumPostcodeReport(brandingId)
                advanceStep('customise')
            } else {
                _generateUnprocessedPremiumReport(brandingId)
                advanceStep('customise')
            }
        }
    }

    const rdSAPComplete = () => {
        advanceStep('cTax')
    }

    // remove file handlers
    const removeXmlAFiles = () => {
        setXMLAFiles([]);
    }
    const removeXmlBFiles = () => {
        setXMLBFiles([]);
    }

    // onDrop handlers
    const xmlAOnDrop = useCallback(acceptedFiles => {
        startUpload(acceptedFiles, 'A');
        setXMLAFiles([...xmlAFiles, ...acceptedFiles]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [xmlAFiles]);
    const xmlBOnDrop = useCallback(acceptedFiles => {
        startUpload(acceptedFiles, 'B');
        setXMLBFiles([...xmlBFiles, ...acceptedFiles]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [xmlBFiles]);

    // dropzone props
    const { getRootProps:getRootPropsXmlA, getInputProps:getInputPropsXmlA } = useDropzone({
        onDrop: xmlAOnDrop,
        disabled: xmlADisabled
    });
    const { getRootProps:getRootPropsXmlB, getInputProps:getInputPropsXmlB } = useDropzone({
        onDrop: xmlBOnDrop,
        disabled: xmlBDisabled
    });

    const userCommandsResetUpload = (which, event) => {
        if (which === 'A') {
            // advances into itself which forces this step and subsequent ones to reset
            advanceStep('uploadLig')
        } else if (which === 'B') {
            // advances into itself which forces this step and subsequent ones to reset
            advanceStep('uploadRdSAP')
        }
    }

    const uploadXmlFollowup = (filename, which_one, originalFilename) => {
        const url = process.env.REACT_APP_API_END_POINT + 'uploadxmlfollowup';
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify({
                filename,
                which_one
            }),
            credentials: "include"
        })
        .then((resp) => resp.json())
        .then((data) => {
            if (data['success'] === true) {
                if (which_one === 'A') {
                    setXmlADetail(<CompletedUpload filename={originalFilename} resetUpload={() => userCommandsResetUpload('A')}/>);
                    ligComplete()
                } else if (which_one === 'B') {
                    setXmlBDetail(<CompletedUpload filename={originalFilename} resetUpload={() => userCommandsResetUpload('B')}/>);
                    rdSAPComplete()
                }
                if ("ctax" in data) { // this will always be returned for upload A and never for B
                    setPostcodePropertyDetails(data['ctax']['addresses']);
                }
            } else {
                if (which_one === 'A') {
                    setXmlADetail(<CompletedUpload success={false} error={data['message']} filename={originalFilename} resetUpload={() => userCommandsResetUpload('A')}/>);
                } else if (which_one === 'B') {
                    setXmlBDetail(<CompletedUpload success={false} error={data['message']} filename={originalFilename} resetUpload={() => userCommandsResetUpload('B')}/>);
                }
            } 
        });
    }

    const uploadComplete = (axiosEvent, filename, originalFilename, which_one) => {
        if (which_one === 'A') {
            setXmlADetail(<strong>Checking file...</strong>);
            setXmlAFilename(filename);
            setOriginalAFilename(originalFilename);
        } else if (which_one === 'B') {
            setXmlBDetail(<strong>Checking file...</strong>);
            setXmlBFilename(filename);
            setOriginalBFilename(originalFilename);
        }
        uploadXmlFollowup(filename, which_one, originalFilename);
    }

    const startUpload = async (files, which_one) => {
        if (which_one === 'A') {
            setXmlADetail(startSpinner);
            setXmlADisabled(true);
        } else if (which_one === 'B') {
            setXmlBDetail(startSpinner);
            setXmlBDisabled(true);
        }
        await uploadFiles(files, which_one);
    }

    const _generatePremiumReport = (useCredit, brandingId = undefined) => {
        advanceStep('final')
        generatePremiumReport({
            xmlAFilename,
            xmlBFilename,
            originalAFilename,
            originalBFilename,
            cTaxPropertyAddress,
            manualCouncilTaxBandActive: manualCouncilTaxBandActive || postcodePropertyDetails.length === 0,
            manualCTaxBand,
            selectedBranding: brandingId === undefined ? selectedBranding : brandingId,
            useCredit
        });
    }

    const _generateUnprocessedPremiumReport = (brandingId = undefined) => {
        setCustomiseReady(false)
        generateUnprocessedPremiumReport({
            xmlAFilename,
            xmlBFilename,
            originalAFilename,
            originalBFilename,
            cTaxPropertyAddress,
            manualCouncilTaxBandActive: manualCouncilTaxBandActive || postcodePropertyDetails.length === 0,
            manualCTaxBand,
            selectedBranding: brandingId === undefined ? selectedBranding : brandingId,
            callback: (reportId) => {
                setUnprocessedReportId(reportId)
                setCustomiseReady(true)
            }
        })
    }

    const _generateUnprocessedPremiumPostcodeReport = (brandingId = undefined) => {
        setCustomiseReady(false)
        generateUnprocessedPremiumPostcodeReport({
            certificateNumber,
            cTaxPropertyAddress,
            manualCouncilTaxBandActive: manualCouncilTaxBandActive || postcodePropertyDetails.length === 0,
            manualCTaxBand,
            selectedBranding: brandingId === undefined ? selectedBranding : brandingId,
            callback: (reportId) => {
                setUnprocessedReportId(reportId)
                setCustomiseReady(true)
            }
        })
    }

    const uploadFiles = (files, which_one) => {

        var extension;
        if (which_one === 'A') {
          extension = 'xml';
        } else if (which_one === 'B') {
          extension = 'xml';
        }
    
        return new Promise((resolve, reject) => {
          const axiosConfig = {
            onUploadProgress: function(progressEvent) {
              var percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              var uploadMessage = percentComplete + "% complete"
              if (which_one === 'A') {
                setXmlADetail(uploadMessage);
              } else if (which_one === 'B') {
                setXmlBDetail(uploadMessage);
              }
            }
          }
    
          const url = process.env.REACT_APP_API_END_POINT + 'upload';
          fetch(url, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                'extension': extension
              }),
              method: "POST",
              credentials: "include"
          })
          .then((resp) => resp.json())
          .then((data) => {
            if (data['success']) {
              if (which_one === 'A') {
                setXmlADetail(sendingSpinner)
              } else if (which_one === 'B') {
                setXmlBDetail(sendingSpinner)
              }
              // got a URL to upload to, in data['upload_to']. Now run the upload...
              axios.put(data['upload_to'], files[0], axiosConfig).then(
                res => {
                  uploadComplete(res, data['filename'], files[0]['name'], which_one)
                  resolve();
                }
              );
            } else {
              if (which_one === 'A') {
                setXmlADetail(data['error']);
              } else if (which_one === 'B') {
                setXmlBDetail(data['error']);
              }
              reject(data['error']);
            }
          })
        });
      }

    const requiresRdSAP = () => {
        return userAccreditationScheme === 'elmhurst';
    }

    useEffect(() => {
        loadBrandings()
    }, [])

    const loadBrandings = () => {
    
        const branding_url = process.env.REACT_APP_API_END_POINT + 'userbrandings/'
        fetch(branding_url, 
          {
            headers: {
              'Accept': 'application/json',
            },
            method: "GET",
            credentials: "include"
          })
          .then((resp) => resp.json())
          .then((data) => {
            if (data['success']) {
              const sortedBrandings = data['brandings'].sort((a, b) => 
                a.company_name.toLowerCase().localeCompare(b.company_name.toLowerCase())
              );
              sortedBrandings.unshift({
                id: 'epIMS',
                company_name: 'epIMS Default Branding',
                colour: '#2260B0',
              })
              setBrandings(sortedBrandings)
            }
          }
        );
      }

    const startSpinner = (
        <div className="my-5" style={{ textAlign: "center" }}>
          <FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "50px", width: "50px" }} />
        </div>
    );

    const sendingSpinner = (
        <div className="my-5" style={{ textAlign: "center" }}>
            <FontAwesomeIcon className="spinner" icon={solid("spinner")} style={{color: "#000000", height: "50px", width: "50px" }} />
        </div>
    );

    const getProgressMeter = () => {

        const elements = []

        if (selectedReportType === 'premium-postcode') {
            const currentPosition = (() => {
                if (currentStep === 'selectAddress') return 1;
                if (currentStep === 'reviewEPC') return 2;
                if (currentStep === 'cTax') return 3;
                if (currentStep === 'manualCTax') return 3;
                if (currentStep === 'branding') return 4;
                return 0;
            })()
            console.log(currentPosition, maxCompletedStep)
            elements.push(<ProgressMeterBlob {...{name: "Select Address", position: 1, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('selectAddress')}} />)
            elements.push(<ProgressMeterBlob {...{name: "Review EPC", position: 2, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('reviewEPC')}} />)
            elements.push(<ProgressMeterBlob {...{name: "Council Tax", position: 3, currentPosition, maxCompletedStep, onClick: () => {manualCouncilTaxBandActive ? setCurrentStep('manualCTax') : setCurrentStep('cTax')}}} />)
            elements.push(<ProgressMeterBlob {...{name: "Branding", position: 4, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('branding')}} />)
        } else {

            const currentPosition = (() => {
                // if (currentStep === 'selectType') return 1;
                if (currentStep === 'uploadLig') return 1;
                if (currentStep === 'uploadRdSAP') return 2;
                if (currentStep === 'cTax') return 3;
                if (currentStep === 'manualCTax') return 3;
                if (currentStep === 'branding') return 4;
                if (currentStep === 'customise') return 5;
                // if (currentStep === 'paymentOptions') return 6;
                return 0;
            })()
            
            elements.push(<ProgressMeterBlob {...{name: "LIG", position: 1, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('uploadLig')}} />)
            if (requiresRdSAP()) {
                elements.push(<ProgressMeterBlob {...{name: "RdSAP", position: 2, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('uploadRdSAP')}} />)
            }
            elements.push(<ProgressMeterBlob {...{name: "Council Tax", position: 3, currentPosition, maxCompletedStep, onClick: () => {manualCouncilTaxBandActive ? setCurrentStep('manualCTax') : setCurrentStep('cTax')}}} />)
            elements.push(<ProgressMeterBlob {...{name: "Branding", position: 4, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('branding')}} />)
            elements.push(<ProgressMeterBlob {...{name: "Customise", position: 5, currentPosition, maxCompletedStep, onClick: () => setCurrentStep('customise')}} />)
            
        }

        return (
            <GenerateReportProgressMeterWrapper>
                <GenerateReportProgressMeter>
                    {elements}
                </GenerateReportProgressMeter>
            </GenerateReportProgressMeterWrapper>
        )
    }

    var _return = [];

    if (currentStep === 'selectType') {
        _return.push(
            <>
                <MobileOnlyWarning />
                {(selectedReportType === 'preliminary' || selectedReportType === 'premium') && getProgressMeter()}
                <ComparisonTable {...{selectPreliminaryReport, selectPremiumReport, premiumCreditsRemaining}} />
            </>
        )
    }

    if (currentStep === 'selectAddress') {
        _return.push(
            <>
                {getProgressMeter()}
                <AddressPicker {...{userClicksAddress, setMaxCompletedStep}} />
            </>
        )
    }

    if (currentStep === 'reviewEPC') {
        _return.push(
            <>
                {getProgressMeter()}
                <ApiEpcReview {...{selectedCertificate, acceptEpc}} />
            </>
        )
    }

    if (currentStep === 'uploadLig') {
        _return.push(
            <div key="ligUploader" style={{width: "100%", height: "100%", display: "flex", flexDirection: "column"}}>
                <MobileOnlyWarning />
                {getProgressMeter()}
                <div>
                    <MainPageTitle>Upload the LIG XML for your {selectedReportType === 'preliminary' ? 'epIMS' : null}{selectedReportType === 'premium' ? 'epIMS' : null} Report</MainPageTitle>
                    <PageExplainer style={{textAlign: "center"}}>Download the LIG XML from your original EPC survey and upload it in the box below</PageExplainer>
                </div>
                <div {...getRootPropsXmlA({className: "dropzone dropzoneGrowable"})}>
                    <input id="ligUploader" {...getInputPropsXmlA()} />
                    { xmlADetail }
                </div>
            </div>
        )
    }

    if (currentStep === 'uploadRdSAP') {
        _return.push(
            <div key="rdSAPUploader" style={{width: "100%", height: "100%", display: "flex", flexDirection: "column"}}>
                <MobileOnlyWarning />
                {getProgressMeter()}
                <div>
                    <MainPageTitle>Upload the RdSAP XML for your {selectedReportType === 'preliminary' ? 'epIMS' : null}{selectedReportType === 'premium' ? 'epIMS' : null} Report</MainPageTitle>
                    <PageExplainer style={{textAlign: "center"}}>Download the RdSAP XML from your original EPC survey and upload it in the box below</PageExplainer>
                </div>
                <div {...getRootPropsXmlB({className: "dropzone dropzoneGrowable"})}>
                    <input id="rdsapUploader" {...getInputPropsXmlB()} />
                    { xmlBDetail }
                </div>
            </div>
        )
    }

    if (currentStep === 'cTax' || currentStep === 'manualCTax') {
        _return.push(
            <>
                {getProgressMeter()}
                <div style={{maxWidth: "800px", marginInline: "auto", display: "flex", flexDirection: "column"}}>
                    <MainPageTitle>Council tax details</MainPageTitle>
                    <PageExplainer>
                        To provide accurate grant funding options for this property, we need to know the council tax band.
                    </PageExplainer>
                    {(currentStep === 'cTax' && postcodePropertyDetails.length !== 0) && <>
                        <PageExplainer>
                            We looked up the council tax bands for properties at this postcode.
                            Sometimes an address appears slightly differently on the council tax register than on the EPC certificate.
                            Please select the correct address from the register below.
                        </PageExplainer>
                        <Button style={{marginInline: "auto", marginBottom: "10px"}} onClick={userClicksCTaxOverride}>Property not listed or details incorrect</Button>
                        {
                            postcodePropertyDetails.map((entry) => { return (
                                <CTaxPropertySelect className={entry.address === cTaxPropertyAddress ? 'selected' : ''} onClick={(e) => userClicksCTaxAddress(entry.address)}>
                                    <div>{entry.address}</div>
                                    <div style={{marginLeft: "20px", flexShrink: 0}}><strong>Band: {entry.band}</strong></div>
                                </CTaxPropertySelect>
                            )})
                        }
                    </>}

                    {(currentStep === 'cTax' && postcodePropertyDetails.length === 0) && <>
                        <p>
                            <span style={{color: "#303030", fontWeight: "bold", border: "2px solid black", borderRadius: "10px", margin: "4px 0px", padding: "4px 6px", backgroundColor: "#FFC8C8"}}>Unfortunately we couldn&apos;t find the council tax details for this property</span>
                        </p>
                    </>}

                    {(currentStep === 'manualCTax' || postcodePropertyDetails.length === 0) && <>
                        <PageExplainer>
                            Please select the correct council tax band for the property. You can check the register directly at: <a target="_blank" rel="noreferrer" href="https://www.gov.uk/council-tax-bands">https://www.gov.uk/council-tax-bands</a>
                        </PageExplainer>
                        {
                            postcodePropertyDetails.length !== 0 && <Button style={{marginInline: "auto", marginBottom: "10px"}} onClick={userClicksRejectCTaxOverride}>Go back to address list</Button>
                        }
                        <div>
                            {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].map((band) => {
                                return <CTaxBandSelect className={band === manualCTaxBand ? 'selected' : ''} onClick={() => userClicksManualCTaxBand(band)}>
                                    <div style={{display: "flex", height: "100%", alignItems: "center", justifyContent: "center"}}><p style={{margin: 0, translate: "0px -3px"}}>{band}</p></div>
                                </CTaxBandSelect>
                            })}
                        </div>
                    </>}

                </div>
            </>
        )
    }

    if (currentStep === 'branding') {
        _return.push(
            <>
                {getProgressMeter()}
                <div style={{maxWidth: "1080px", marginInline: "auto", display: "flex", flexDirection: "column"}}>
                    <MainPageTitle>Select report branding</MainPageTitle>
                    <PageExplainer>You can add your own company name and logo to our reports. To create a new branding option visit 'Branding' in 'Settings'.</PageExplainer>
                    <div style={{display: "flex", flexWrap: "wrap", flexDirection: "row", columnGap: "20px", rowGap: "20px", justifyContent: "flex-start" }}>
                        {brandings.map((branding) => {
                            return (
                                <ImageOptionTile className={branding.id === selectedBranding ? 'selected' : ''} onClick={() => userClicksBranding(branding.id)}>
                                    <div style={{display: "flex", width: "100%", height: "100px", border: "10px solid " + branding.colour, borderRadius: "10px 10px 0px 0px", backgroundColor: branding.colour}}>
                                        {(branding.image_url || branding.id === 'epIMS') && <div style={{width: "100%", height: "100%", backgroundImage: "url('" + (branding.id === 'epIMS' ? '/epims_logo.png' : branding.image_url) + "')", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>}
                                        {(!branding.image_url && branding.id !== 'epIMS') && <p style={{margin: "auto", fontSize: "40px", textShadow: "1px 1px 0 white, -1px -1px 0 white, -1px 1px 0 white, 1px -1px 0 white"}}>No Logo</p>}
                                    </div>
                                    <div style={{width: "100%", height: "80px", padding: "4px", display: "flex"}}>
                                        <p style={{margin: "auto", textAlign: "center", fontSize: "20px"}}>{branding.company_name}</p>
                                    </div>
                                </ImageOptionTile>
                            )
                        })}
                        <ImageOptionTile onClick={() => navigate('/branding/new')} style={{borderStyle: "dashed"}}>
                            <div style={{display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center", justifyContent: "center"}}>
                                <div style={{display: "flex", width: "100%", height: "100px", border: "10px solid white", borderRadius: "10px 10px 0px 0px", backgroundColor: "white", alignItems: "center", justifyContent: "center"}}>
                                    <p style={{margin: 0, fontSize: "100px", translate: "0px -12px"}}>+</p>
                                </div>
                                <div style={{width: "100%", height: "80px", padding: "4px", display: "flex"}}>
                                    <p style={{margin: "auto", textAlign: "center", fontSize: "20px"}}>Create New</p>
                                </div>
                            </div>
                        </ImageOptionTile>
                    </div>
                </div>
            </>
        )
    }

    var displayCustomiser = true;
    if (currentStep === 'customise') {
        _return.push(getProgressMeter())
        if (!customiseReady) {
            displayCustomiser = false;
            _return.push(
                <div className="my-5" style={{ textAlign: "center" }}>
                    <div className="my-5">Loading</div>
                    <div><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "150px", width: "150px" }} /></div>
                </div>
            )
        }
    } else {
        displayCustomiser = false
    }

    if (unprocessedReportId !== null) {
        _return.push(
            <>
                <div style={{display: displayCustomiser ? 'block' : 'none'}}>
                    <ProcessReportPage key={"customiser-" + unprocessedReportId} reportId={unprocessedReportId} selectedReportType={selectedReportType} />
                </div>
            </>
        )
    }


    return _return;

}

export default UploadXmlForm;

